<template>
  <div>
    <monthly-summary-table
      v-if="monthlySumary"
      :monthly-summary="monthlySumary"
      :loading="monthlySumary.loading"
      :months="months"
      @onIelPaymentClick="getIelPayment"
      @onPNCProductsClick="showPNCProducts"
      @onGenNProductsClick="showGenNProducts"
    >
      <template #avg-delivery-rows>
        <avg-delivery-rows
          v-if="!isAvgDeliveryDisabledByRole"
          :username="username"
          :chnl="chnl"
        />
      </template>
    </monthly-summary-table>
    <alert-prominent v-if="error" :message="error" />
    <new-products
      v-model="products.modal"
      :title="products.title"
      :data="products.data"
      period-key="periods"
      :loading="products.loading"
      :error="error"
      :sub-title="products.subTitle"
    />
    <customers-i-e-l
      v-model="ielCustomers.modal"
      :data="ielCustomers.data"
      :loading="ielCustomers.loading"
      :title="ielCustomers.title"
    />
  </div>
</template>

<script>
  import service from '@/mixins/service';
  import numbers from '@/mixins/numbersFormats';
  import dates from '@/mixins/dates';
  import activeUsernameMixin from '@/mixins/activeUsernameMixin';
  import { Roles } from '@/core/constants/roleConstants';
  import {
    getResumeSummary,
    getPncProducts,
    getGenNProducts,
    getCustomersViaIel,
  } from '@/repositories/Daily';
  import MonthlySummaryTable from '../components/MonthlySummaryTable.vue';
  import AvgDeliveryRows from '../components/AvgDeliveryRows.vue';
  import NewProducts from '@/views/daily/modals/NewProducts.vue';
  import CustomersIEL from '@/views/daily/modals/CustomersIEL.vue';
  import AlertProminent from '@/components/AlertProminent.vue';

  export default {
    name: 'MonthlySummary',
    components: {
      MonthlySummaryTable,
      AvgDeliveryRows,
      AlertProminent,
      NewProducts,
      CustomersIEL,
    },
    mixins: [service, numbers, dates, activeUsernameMixin],
    props: {
      userId: {
        default: '',
        type: String,
      },
      chnl: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        username: '',
        monthlySumary: {
          data: null,
          loading: false,
          error: '',
        },
        loading: true,
        months: [],
        disabledToRoles: [Roles.MANAGER],
        products: {
          data: {},
          loading: true,
          modal: false,
          title: '',
          subTitle: '',
        },
        ielCustomers: {
          data: {},
          loading: true,
          modal: false,
          title: '',
          subTitle: '',
        },
        error: '',
      };
    },
    computed: {
      isAvgDeliveryDisabledByRole() {
        if (!this.disabledToRoles.length) return false;
        return this.$hasAnyRole(this.disabledToRoles);
      },
    },
    created() {
      this.months = this.calcularUltimosMeses(7).reverse();
    },
    mounted() {
      this.username = this.userId ? this.userId : this.activeUsername?.username;
      this.getData();
    },
    methods: {
      async getData() {
        this.monthlySumary.loading = true;
        try {
          const data = await getResumeSummary(this.username, this.chnl);
          this.monthlySumary = data;
          this.monthlySumary.loading = false;
        } catch (error) {
          this.monthlySumary.error =
            'No se ha podido cargar la información correctamente. Por favor, intente más tarde.';
          this.monthlySumary.loading = false;
        }
      },
      async showPNCProducts() {
        this.products.title = 'Detalle de productos PNC';
        this.products.subTitle = 'Productos PNC';
        this.products.loading = true;
        this.products.modal = true;
        try {
          const data = await getPncProducts(this.username, this.chnl);
          this.products.data = data;
        } catch (error) {
          this.products.modal = false;
          this.$toast.error(
            `Hubo problemas al cargar ${this.products?.title}, por favor intente más tarde.`
          );
        }
        this.products.loading = false;
      },
      async showGenNProducts() {
        this.products.title = 'Detalle de productos Gen. N';
        this.products.subTitle = 'Productos Gen. N';
        this.products.loading = true;
        this.products.modal = true;
        try {
          const data = await getGenNProducts(this.username, this.chnl);
          this.products.data = data;
        } catch (error) {
          this.products.modal = false;
          this.$toast.error(
            `Hubo problemas al cargar ${this.products?.title}, por favor intente más tarde.`
          );
        }
        this.products.loading = false;
      },
      async getIelPayment(period = null) {
        this.ielCustomers.loading = true;
        this.ielCustomers.title = `Detalle de clientes con pago vía IEL`;
        this.ielCustomers.modal = true;
        try {
          const data = await getCustomersViaIel(
            this.username,
            this.chnl,
            period
          );
          this.ielCustomers.data = period
            ? data.periods[period] ?? []
            : data.average ?? [];
        } catch (error) {
          this.ielCustomers.modal = false;
          this.$toast.error(
            'Hubo problemas al cargar los clientes con pago vía IEL, por favor intente más tarde.'
          );
        }
        this.ielCustomers.loading = false;
      },
    },
  };
</script>
